import React from 'react';
import useFluxAutomaticFilterSelector from 'utils/hooks/flux/automatic/filterSelector';
import { automaticOptionMap } from 'helper/flux/automatic';
import Tag from 'components/DesignSystem/Tag';
import './index.scss';

export default function ActiveFilters() {
  const { currentSubOption, clearFilter } = useFluxAutomaticFilterSelector();

  if (currentSubOption === undefined) {
    return <div />;
  }

  const label = currentSubOption?.spacialSubdivisionOption.label;
  const subdivisionName = automaticOptionMap[currentSubOption.spatialSubdivision];
  const buttonText = `${subdivisionName.toUpperCase()} - ${label}`;

  return (
    <div className="mx-3 d-flex align-items-center flex-grow-1 flex-wrap">
      <Tag
        type="primary"
        icon="close"
        iconPlacement="trailing"
        key={`${currentSubOption?.spatialSubdivision}-${currentSubOption?.spacialSubdivisionOption.value}`}
        onClick={clearFilter}
      >
        {buttonText}
      </Tag>
    </div>
  );
}
